import { Box, Divider, Text, Checkbox } from "@chakra-ui/react";
import { TenantUsuarioFormulario } from "core/features/tenants/typings/tenant";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PrimaryButton from "components/Button/PrimaryButton";
import DadosDoResponsavel from "./DadosDoResponsavel";
import {
  useSaveTenantUsuario,
  useGetTenantUsuario,
} from "features/tenants/hooks";
import { TipoTenantEnum } from "core/resources/enums/tenant";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useLoading } from "components/GlobalLoading";
import Button from "components/Button";
import Field from "components/Input/Field";
import SelectPessoas from "components/Input/SelectPessoas";
import { useState } from "react";
import SelectPerfil from "components/Input/SelectPerfil";
import { Col, Modal, Row } from "antd";
import { TipoEntidadeEnum } from "resources/enums/conta";
import InputCondominiosLiberados from "./UsuariosTable/components/InputCondominiosLiberados";

interface ModalCadastroEditarProps {
  isOpen: boolean;
  onClose: () => any;
  onSaved: () => any;
  usuarioId?: string;
  tenantId: string;
  tipoTenantId: TipoTenantEnum;
}

function ModalCadastroEditar({
  isOpen,
  onClose,
  onSaved,
  usuarioId,
  tenantId,
  tipoTenantId,
}: ModalCadastroEditarProps) {
  const { control, handleSubmit, reset } = useForm<TenantUsuarioFormulario>({
    reValidateMode: "onChange",
    mode: "onTouched",
    defaultValues: {
      pessoa: {
        contatos: [],
      },
    },
  });

  const [hasProprietario, setHasProprietario] = useState(false);

  const {
    data,
    isLoading: loadingEditUserData,
    isFetching,
  } = useGetTenantUsuario({
    tenantId,
    usuarioId,
  });

  const { mutate: handleSave, isLoading: isLoadingSave } = useSaveTenantUsuario(
    tenantId,
    usuarioId
  );

  useLoading(loadingEditUserData || isFetching);

  useEffect(() => {
    if (data) {
      reset({
        ...data,
      });
    }
  }, [data, reset]);

  const onSubmit = (data: TenantUsuarioFormulario) => {
    handleSave(
      {
        dataFimAcesso: data.dataFimAcesso,
        id: usuarioId!,
        perfilId: data.perfilId,
        pessoaId: data.pessoaId,
        pessoa: {
          ...data.pessoa,
          contatos: Array.isArray(data.pessoa.contatos)
            ? data.pessoa.contatos
            : [],
        },
        endereco: data.endereco,
        tenants: data.tenants,
      },
      {
        onSuccess: () => showSuccess(`Usuário salvo com sucesso`).then(onSaved),
        onError: (err) => showErrorAxios(err),
      }
    );
  };

  const isCondominio = tipoTenantId === TipoTenantEnum.Condominio;

  const showCondominios = [
    TipoTenantEnum.Administradora,
    TipoTenantEnum.Incorporadora,
  ].includes(tipoTenantId);

  return (
    <Modal
      visible={isOpen}
      title={
        <Text as="h3" fontSize={20}>
          {usuarioId ? "Editar" : "Cadastrar novo"} usuário
        </Text>
      }
      footer={
        <Box
          display="flex"
          gridGap={6}
          justifyContent="flex-end"
          flex={1}
          mt={8}
        >
          <Button
            onClick={onClose}
            disabled={isLoadingSave || loadingEditUserData}
          >
            Cancelar
          </Button>
          <PrimaryButton
            onClick={() => handleSubmit(onSubmit)()}
            isLoading={isLoadingSave || loadingEditUserData}
            disabled={isLoadingSave || loadingEditUserData}
          >
            Salvar
          </PrimaryButton>
        </Box>
      }
      onCancel={onClose}
      width="650px"
    >
      <form onSubmit={(ev) => handleSubmit(onSubmit)(ev)}>
        <>
          {isCondominio && !usuarioId ? (
            <Checkbox
              mb="32px"
              isChecked={hasProprietario}
              onChange={() => setHasProprietario((prev) => !prev)}
            >
              Já possui cadastro ?
            </Checkbox>
          ) : null}

          {hasProprietario ? (
            <Box mb="16px">
              <Field
                label="Procurar pessoa"
                name="pessoaId"
                control={control}
                render={({ field, isInvalid }) => (
                  <SelectPessoas
                    showSearch
                    tenantId={tenantId}
                    isInvalid={isInvalid}
                    tipoEntidades={[TipoEntidadeEnum.Condomino]}
                    {...field}
                  />
                )}
              />
            </Box>
          ) : null}

          {!hasProprietario ? (
            <DadosDoResponsavel edit={!!usuarioId} control={control} />
          ) : null}

          <Divider my={4} />

          <Box as={Row} gutter={32}>
            <Col md={12}>
              <Field
                label="Cargo"
                control={control}
                name="perfilId"
                render={({ field, isInvalid }) => (
                  <SelectPerfil
                    isInvalid={isInvalid}
                    tenantId={tenantId}
                    mode={undefined}
                    placeholder="Selecione um perfil"
                    {...field}
                  />
                )}
                rules={{
                  required: "Campo obrigatório",
                }}
              />
            </Col>

            <Col md={12}>
              <Field
                label="Data de fim de acesso"
                control={control}
                name="dataFimAcesso"
                inputProps={{
                  type: "date",
                }}
              />
            </Col>
          </Box>

          {showCondominios ? (
            <Box mt="20px">
              <Field
                control={control}
                shouldUnregister
                name="tenants"
                render={({ field }) => (
                  <InputCondominiosLiberados
                    tenantId={tenantId}
                    value={field.value}
                    onChange={field.onChange}
                  />
                )}
              />
            </Box>
          ) : null}

          {/* {watch('perfilId') && tipoTenantId === TipoTenantEnum.Condominio ? (
            <>
              <br />
              <DadosDeMandato control={control} />
              <Divider my={4} />
            </>
          ) : null} */}
        </>
      </form>
    </Modal>
  );
}

export default ModalCadastroEditar;
